import {useRootStore} from '@/store'
import {selectChoosePaymentsMethodModal, selectErrorModal, selectUpdateCreditCardModal} from '@/store/selectors'
import {Fragment, useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {CardUpdateTypes} from '../../constants/card'
import {SubscriptionsStatusE, SubscriptionV3} from '../../types'
import {SupportedUser} from '../supported-user/SupportedUser'
import {StyledButton, StyledCardNumber, StyledListOfSupportedUsers, StyledListOfSupportedUsersContainer} from './style'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useUpdateCreditCard} from '@/features/profile/queries/useUpdateCreditCard'
import {PaymentMethodUrls} from '@/features/guest-payments/types'
import {useGetSubscriptionsToRenewV3} from '../../queries/useGetSubscriptionsToRenewV3'
import {useRenewSubscriptionV3} from '../../queries/useRenewSubscriptionV3'

export const ListOfSupportedUsers = () => {
    const {t} = useTranslation()
    const {data, isLoading} = useGetSubscriptionsToRenewV3()

    const correctData: SubscriptionV3[] = [
        ...(data?.subscriptions ? data.subscriptions : []),
        ...(data?.errors ? data.errors : [])
    ] as SubscriptionV3[]

    const splitByCard = correctData.reduce(
        (acc, item) => {
            const last4 = String(item.last4)
            if (last4 in acc) acc[last4].push(item)
            else acc[last4] = [item]

            return acc
        },
        {} as {[key: string]: SubscriptionV3[]}
    )
    const [selectedSubscriptions, setSelectedSubscriptions] = useState<SubscriptionV3[]>(correctData)
    const {
        mutate: renewSubscription,
        error: errorsRenewSubscription,
        isPending: isPendingRenew
    } = useRenewSubscriptionV3()
    const {openErrorModal} = useRootStore(selectErrorModal)
    const {closeModal: closeModalUpdateCreditCardModal} = useRootStore(selectUpdateCreditCardModal)
    const {openModal: openChoosePaymentsMethodModal} = useRootStore(selectChoosePaymentsMethodModal)
    const {mutate: updateCreditCard, error: paymentMethods, isPending: isPendingUpdate} = useUpdateCreditCard()
    const isPending = isPendingRenew || isPendingUpdate

    const onSelectSelectedSubscription = (selectedSubscriptionID: number) => {
        setSelectedSubscriptions(prevSelectedSubscriptions =>
            prevSelectedSubscriptions.map(prevSelectedSubscription =>
                prevSelectedSubscription.id === selectedSubscriptionID
                    ? {
                          ...prevSelectedSubscription,
                          status:
                              prevSelectedSubscription.status === SubscriptionsStatusE.Active
                                  ? SubscriptionsStatusE.Inactive
                                  : SubscriptionsStatusE.Active
                      }
                    : prevSelectedSubscription
            )
        )
    }

    const onSubmit = () => {
        const isRenew = !selectedSubscriptions.find(item => item.status === SubscriptionsStatusE.Active)
        !isRenew
            ? renewSubscription({
                  needCcbill: true,
                  type: CardUpdateTypes.NEW_CARD,
                  subscriptions: selectedSubscriptions
                      .filter(selectedSubscription => selectedSubscription.status === SubscriptionsStatusE.Active)
                      .map((selectedSubscription: SubscriptionV3) => ({
                          id: selectedSubscription.id.toString(),
                          action: 'update'
                      }))
              })
            : updateCreditCard()
    }

    useEffect(() => {
        data && setSelectedSubscriptions(correctData)
    }, [data])

    useEffect(() => {
        if (errorsRenewSubscription || paymentMethods) {
            if (errorsRenewSubscription?.response?.status === 303 || paymentMethods) {
                openChoosePaymentsMethodModal({
                    paymentMethodUrls:
                        errorsRenewSubscription?.response?.data ||
                        (paymentMethods?.response?.data as PaymentMethodUrls),
                    isRecurring: true,
                    isUpdateCreditCard: true,
                    apiCallback: onSubmit
                })
            } else {
                !!errorsRenewSubscription && openErrorModal({message: errorsRenewSubscription.message})
            }
            closeModalUpdateCreditCardModal()
        }
    }, [errorsRenewSubscription, paymentMethods])

    return (
        <>
            {isLoading || isPending ? (
                <Spinner />
            ) : (
                <StyledListOfSupportedUsersContainer>
                    <StyledListOfSupportedUsers>
                        {Object.keys(splitByCard).map(card => (
                            <Fragment key={card}>
                                <StyledCardNumber>
                                    {t('update_recurring_transactions:card_numbers', {
                                        CARD_LAST_4: card !== 'null' ? card : ''
                                    })}
                                </StyledCardNumber>
                                {splitByCard[card].map(subscription => (
                                    <SupportedUser
                                        key={subscription.id}
                                        subscription={subscription}
                                        onSelect={() => onSelectSelectedSubscription(subscription.id)}
                                    />
                                ))}
                            </Fragment>
                        ))}
                        {/* <StyledDescriptionEndList>
                            {t('active_gifting_leaders:description_end_list')}
                        </StyledDescriptionEndList> */}
                    </StyledListOfSupportedUsers>
                    <StyledButton onClick={onSubmit}>{t('leader_payments:cta')}</StyledButton>
                </StyledListOfSupportedUsersContainer>
            )}
        </>
    )
}
